import React, { useEffect } from "react";
import { Col, Form, Modal, Row, Select } from "antd";
import capitalize from "@/utils/capitalize";
import { ScanStatuses } from "@/utils/enum";

const EditScanStatusModal = ({ isOpen, title, status, submitCallback, cancelCallback }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    const initialStatus =
      ([ScanStatuses.SUCCESS, ScanStatuses.MANUAL_SUCCESS].includes(status) && "pass") ||
      ([ScanStatuses.FAIL, ScanStatuses.MANUAL_FAIL].includes(status) && "fail");

    if (initialStatus) {
      form.setFieldsValue({ status: capitalize(initialStatus) });
    }
  }, [isOpen, status, form]);

  useEffect(() => {
    if (!isOpen) {
      form.setFieldsValue({ status: null });
    }
  }, [isOpen, form]);

  const onOk = data => {
    submitCallback(data.status);
  };

  return (
    <Modal title={title} open={isOpen} onOk={form.submit} onCancel={() => cancelCallback?.()}>
      <Form form={form} onFinish={onOk}>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item name="status" rules={[{ required: true, message: "Select a valid status" }]}>
              <Select placeholder="Status" style={{ width: "60%" }}>
                <Select.Option key="pass" value={ScanStatuses.MANUAL_SUCCESS}>
                  Pass
                </Select.Option>
                <Select.Option key="fail" value={ScanStatuses.MANUAL_FAIL}>
                  Fail
                </Select.Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default EditScanStatusModal;
